import { Component, OnDestroy } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { Member } from '@app/shared/models/member';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GroupsActions } from '../../actions';
import * as fromGroups from '../../reducers/groups.reducer';

@Component({
  selector: 'app-modal-detach-member',
  templateUrl: './modal-detach-member.component.html',
  styleUrls: ['./modal-detach-member.component.scss']
})
export class ModalDetachMemberComponent implements OnDestroy {

  memberToDetach: Member;
  group: Group;

  detachMemberFromGroupPending$: Observable<boolean>;
  detachMemberFromGroupSuccess$: Observable<boolean>;
  detachMemberFromGroupError$: Observable<any>;

  submitted = false;
  subscriptions: Subscription[] = [];
  teamId: string;

  constructor(private store$: Store<fromRoot.State & fromGroups.State>, public ref: DialogRef) {
    this.memberToDetach = this.ref.data.memberToDetach;
    this.group = this.ref.data.group;
    this.teamId = this.ref.data.teamId;

    this.detachMemberFromGroupPending$ = this.store$.select(fromGroups.getDetachMemberFromGroupPending);
    this.detachMemberFromGroupSuccess$ = this.store$.select(fromGroups.getDetachMemberFromGroupSuccess);
    this.detachMemberFromGroupError$ = this.store$.select(fromGroups.getDetachMemberFromGroupError);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.ref.close();
  }

  detachMemberFromGroup(userId: string, groupId: string) {
    this.store$.dispatch(GroupsActions.DetachMemberFromGroup({ teamId: this.teamId, userId: this.memberToDetach.id, groupId: this.group.id }));
    this.subscriptions.push(
      this.detachMemberFromGroupSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(GroupsActions.LoadGroupMembers({ teamId: this.teamId, id: this.group.id }));
          this.close();
        }
      })
    );
  }
}
